<template>
    <div ref="scrollIndicatori">
        <div class="white-box mt-3">
            <div class="data-group">
                <M3FormTitle title="Indicatori proiect" :checked="completed"></M3FormTitle>
<!--                <div class="adauga-asociat mb-5 mt-3" @click="addSupResult()">-->
<!--                    <div class="add-button">-->
<!--                        <p>Adaugă un indicator suplimentar de rezultat</p>-->
<!--                        <b-icon-plus-circle-fill font-scale="1.2"></b-icon-plus-circle-fill>-->
<!--                    </div>-->
<!--                </div>-->
                <b-form v-if="indicators" @submit.prevent>
                    <div class="activitate">
                        <div class="header">
                            <span class="title">
                                <strong>Indicatori prestabiliți de rezultat</strong>
                            </span>
                        </div>
                        <div class="sub-item green">
                            <span class="title flex align-center space-between">
                                <span class="ml-2"></span>
                                <span class="points">N/A</span>
                            </span>
                        </div>
                    </div>
                    <div class="activitate">
                        <div class="header">
                            <span class="title">
                                <strong>Indicatori prestabiliți de realizare</strong>
                            </span>
                        </div>
                        <div class="sub-item green">
                            <span class="title flex align-center space-between">
                                <span class="ml-2"> {{ indicators.achievement.title }}</span>
                                <span class="points">{{ indicators.achievement.number }}</span>
                            </span>
                        </div>
                    </div>
                    <div class="activitate">
                        <div class="header">
                            <span class="title">
                                <strong>Indicatori suplimentari de rezultat</strong>
                            </span>
                        </div>
                        <div v-for="(indicator, key) in indicators.supResult" :key="key" class="sub-item green">
                            <span class="title flex align-center space-between">
                                <span v-if="editing !== indicator.id || !indicator.canEdit" class="ml-2"> {{ indicator.title }}</span>
                                <b-form-input v-else-if="editing === indicator.id && indicator.canEdit" v-model="indicator.title" class="ml-2" style="width: 60%;"></b-form-input>
                                <span v-if="editing !== indicator.id" class="points">{{ indicator.number }} <span v-if="indicator.hasPercent">%</span></span>
                                <b-form-input v-else-if="editing === indicator.id && indicator.hasPercent" v-model="indicator.number" type="number" :formatter="formatIndicator" class="ml-2" style="width: 8%;" @keyup="checkPercentage(indicator.number)"></b-form-input>
                                <b-form-input v-else-if="editing === indicator.id && !indicator.hasPercent" v-model="indicator.number" :formatter="formatIndicator" class="ml-2" style="width: 8%;"></b-form-input>
                            </span>
                            <div class="actions">
                                <b-icon-pencil-square v-if="!indicator.hasPercent && editing !== indicator.id" font-scale="1.2" @click="toggleEdit(indicator.id)"></b-icon-pencil-square>
                                <b-icon-pencil-square v-else-if="indicator.hasPercent && editing !== indicator.id" font-scale="1.2" @click="toggleEdit(indicator.id)"></b-icon-pencil-square>
                                <b-icon-check-circle-fill v-else font-scale="1.2" :class="errorInput ? 'pointer-none' : ''" @click="saveEdit()"></b-icon-check-circle-fill>
                                <b-icon-trash v-if="indicator.canDelete" font-scale="1.2" @click="deleteIndicator(indicator.id)"></b-icon-trash>
                            </div>
                        </div>
                        <div v-if="warnMessage2" class="warn"><span><strong>Atenție!</strong> Vei pierde puncte din punctajul proiectului tău!</span></div>
                        <!--                        <div class="red-warn">
							<img src="@/assets/images/M3/M3Sketch/sad.png" class="sad-face">
							<div class="red-warn-text">
								<h3>Din păcate, nu avem nici o putere aici...</h3>
								<p>Din păcate nu avem acces la informațiile necesare generării indicatorului de productivitate a muncii. Acest indicator provine din situațiile financiare ale companiei tale, informații disponibile exclusiv contabilului companiei. Descarcă fișierul atașat și roaga-l pe contabil să completeze câmpurile necesare,  iar apoi, completează tu zona de previziuni. Editează câmpul de mai sus (%). </p>
							</div>
							<a href="/documents/proiectii-411.xlsx" download class="red-warn-download">
								<img src="@/assets/images/M3/M3Sketch/excel-icon.png" class="excel-download">
								<p>DESCARCĂ DOCUMENTUL</p>
							</a>
						</div>-->

                    </div>
                    <div class="activitate">
                        <div class="header">
                            <span class="title">
                                <strong>Indicatori suplimentari de realizare</strong>
                            </span>
                        </div>
                        <div class="sub-item green">
                            <span class="title flex align-center space-between">
                                <span class="ml-2"> {{ indicators.supAchievement.title }}</span>
                                <span v-if="editing !== 1" class="points">{{ indicators.supAchievement.number }}</span>
                                <b-form-input v-else v-model="indicators.supAchievement.number" type="number" :formatter="formatIndicator" class="ml-2" style="width: 5%" @keyup="checkScore(indicators.supAchievement.number)"></b-form-input>
                            </span>
                            <div class="actions">
                                <b-icon-pencil-square v-if="editing !== 1" font-scale="1.2" @click="toggleEdit(1)"></b-icon-pencil-square>
                                <b-icon-check-circle-fill v-else font-scale="1.2" :class="errorInput ? 'pointer-none' : ''" @click="saveEdit(indicators.supAchievement.number)"></b-icon-check-circle-fill>
                            </div>
                        </div>
                        <div v-if="warnMessage" class="warn yellow-warn"><span><strong>Atenție!</strong> Vei pierde 5 puncte din punctajul proiectului tău!</span></div>
                    </div>
                    <div class="activitate">
                        <div class="header">
                            <span class="title">
                                <strong>Numărul de angajați în anul 3 de sustenabilitate (2026)</strong>
                            </span>
                        </div>
                        <div class="sub-item yellow">
                            <span class="title flex align-center space-between">
                                <span class="ml-2 px-3" v-html="indicators.employees ? indicators.employees.title : ''"></span>
                                <span class="angajatiItem">
                                    <span class="angajatiTitle">Angajați 2019</span>
                                    <span v-if="editing !== 2" class="points">
                                        {{ indicators.employees.number2019 }}
                                    </span>
                                    <span v-else class="points editAngajati">
                                        <b-form-input v-model="indicators.employees.number2019" type="number" class="ml-2" @keyup="checkEmployeesTermene(indicators.employees.number2019)"></b-form-input>
                                    </span>
                                </span>
                                <span class="angajatiItem">
                                    <span class="angajatiTitle">Angajați 2026</span>
                                    <span v-if="editing !== 2" class="points">
                                        {{ indicators.employees.number }}
                                    </span>
                                    <span v-else class="points editAngajati">
                                        <b-form-input v-model="indicators.employees.number" type="number" class="ml-2" @keyup="checkEmployees(indicators.employees.number)"></b-form-input>
                                    </span>
                                </span>
                            </span>
                            <div class="actions">
                                <b-icon-pencil-square v-if="editing !== 2" font-scale="1.2" @click="toggleEdit(2)"></b-icon-pencil-square>
                                <b-icon-check-circle-fill v-else font-scale="1.2" :class="errorInput ? 'pointer-none' : ''" @click="saveEdit(indicators.employees.number, 'angajati')"></b-icon-check-circle-fill>
                            </div>
                        </div>
                        <div v-if="warnTermene" class="warn yellow-warn-termene"><span><strong>Atenție!</strong> Numărul de angajați aferent anului 2019 nu coincide cu informațiile primite de Smis. Această modificare se va face pe răspunderea dumneavoastră și nu ne asumăm eventualele situații de respingere a cererii de finanțare.</span></div>
                        <div v-if="warnEmployees" class="warn red-warn" :class="blinker ? 'blinker' : ''"><span><strong>Atenție!</strong> Numărul de angajați aferent anului 3 de sustenabilitate nu poate fi mai mic decât numărul de angajați din anul 2019.</span></div>
                        <div v-if="documentEmployees2026 && documentEmployees2026 != indicators.employees.number" class="warn red-warn" :class="blinker ? 'blinker' : ''"><span><strong>Atenție!</strong> Indicatorul din fisier ({{ documentEmployees2026 }} <span v-if="documentEmployees2026 == 1">angajat</span><span v-else>angajați</span>) nu coincide cu cel asumat ({{ indicators.employees.number }} <span v-if="indicators.employees.number == 1">angajat</span><span v-else>angajați</span>).</span></div>
                        <div v-if="documentEmployees2019 && documentEmployees2019 != indicators.employees.number2019" class="warn red-warn" :class="blinker ? 'blinker' : ''"><span><strong>Atenție!</strong> Indicatorul din fisier ({{ documentEmployees2019 }} <span v-if="documentEmployees2019 == 1">angajat</span><span v-else>angajați</span>) nu coincide cu numărul de angajați din anul 2019 ({{ indicators.employees.number2019 }} <span v-if="indicators.employees.number == 1">angajat</span><span v-else>angajați</span>).</span></div>
                        <div class="row file-uploads">
                            <div :class="documentPercentage ? 'col-md-8' : 'col-md-12'">
                                <div class="activitate">
                                    <div class="header">
                                        <span class="subtitle">Te rugăm să descarci .xls – documentul pentru proiecții financiare și să îl completezi alături de contabil sau un consultant/expert financiar. Încarcă documentul în câmpul predefinit.</span>
                                    </div>
                                    <div class="sub-item-flex">
                                        <a href="/documents/Previziuni-financiare-(edit_smis)-v3.0.xlsx" download class="green-item" style="width: 49%;">
                                            <img src="@/assets/images/M3/M3Sketch/excel-icon.png" class="excel-download" style="height: auto; align-self: flex-start;">
                                            DESCARCĂ ȘABLON
                                        </a>
                                        <div class="green-item" style="width: 49%;" @click="pickFile()">
                                            <img src="@/assets/images/M3/M3Sketch/excel-icon.png" class="excel-download" style="height: auto; align-self: flex-start;">
                                            <span v-if="documentPercentage">RE</span>ÎNCARCĂ DOCUMENTUL
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="documentPercentage" class="col-md-4">
                                <div class="activitate">
                                    <div class="header">
                                        <span class="subtitle">Productivitatea muncii în anul 3 de sustenabilitate conform previziunilor încărcate</span>
                                    </div>
                                    <div class="sub-item-flex">
                                        <div :class="Number(documentPercentage) !== Number(indicators.supResult[0].number) ? 'red-item blinker' : 'green-item-special'">
                                            <p>{{ documentPercentage }}%</p>
                                            <img v-if="Number(documentPercentage) !== Number(indicators.supResult[0].number)" src="@/assets/images/M3/M3Sketch/warn-sign-red.png" alt="warn-sign" class="warn_image" style="height: auto; align-self: flex-start;">
                                        </div>
                                    </div>
                                    <p v-if="Number(documentPercentage) !== Number(indicators.supResult[0].number)" style="color: #ff5555; font-weight: 600;">Indicatorul din fișier ({{ documentPercentage }}%) nu coincide cu cel asumat ({{ indicators.supResult[0].number }}%)</p>
                                </div>
                            </div>
                        </div>
                        <div v-if="documentPercentage" class="row">
                            <div class="col-md-8">
                                <div class="green-item-nohover">
                                    <p class="mb-0 font-weight-bolder" style="font-size: 14px;">Document încărcat cu succes!</p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <p class="green-item" @click="downloadForecast()">
                                    <img src="@/assets/images/M3/M3Sketch/excel-icon.png" class="excel-download" style="height: auto; align-self: flex-start;">
                                    DESCARCĂ FIȘIERUL ÎNCĂRCAT
                                </p>
                            </div>
                        </div>

                    </div>
                    <input ref="fileUpload" type="file" style="display:none" @change="uploadFile">
                    <hr class="mt-5">
                    <b-form-checkbox
                        v-model="completed"
                        switch
                        size="lg"
                        class="switch-box"
                        @change="completeForm()"
                    >Informațiile sunt complete și corecte</b-form-checkbox>
                </b-form>
            </div>
            <p id="scrollAuxiliary" style="display: none; margin-top:200px">&nbsp;</p>
        </div>
    </div>
</template>

<script>
    import M3FormTitle from '../M3FormTitle'
    import { BForm, BFormInput, BIconPencilSquare, BIconTrash, BIconCheckCircleFill, BFormCheckbox, BIconPlusCircleFill} from "bootstrap-vue";
    import draggable from 'vuedraggable'
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';
    import Vue from 'vue';
    import VueSweetalert2 from 'vue-sweetalert2';
    Vue.use(VueSweetalert2);
    require('@/helpers/validations/validations')
    export default {
        components: {
            BForm,
            BFormInput,
            BIconPencilSquare,
            BIconTrash,
            BIconCheckCircleFill,
            BFormCheckbox,
            M3FormTitle,
            BIconPlusCircleFill,
            draggable,
            VueSweetalert2
        },
        props: {
            indicatori: null,
        },
        data() {
            return {
                nrAngajati2019: '',
                blinker: false,
                completed: null,
                title: 'Test 1',
                warnMessage: false,
                warnMessage2: false,
                warnEmployees: false,
                errorInput: false,
                documentPercentage: null,
                documentEmployees2026: null,
                documentEmployees2019: null,
                editing: false,
                indicators: {
                    achievement: {
                        id: 0,
                        title: 'Număr de întreprinderi sprijinite',
                        number: '1'
                    },
                    result: {
                        id: 2,
                        title: 'Număr de întreprinderi sprijinite',
                        number: '1'
                    },
                    supAchievement: {
                        id: 3,
                        title: 'Număr de noi produse – bunuri sau servicii - și procese inovative introduse pe piață de către beneficiar',
                        number: '1'
                    },
                    employees: {
                        id: 4,
                        title: 'Numărul de angajați în anul 3 de sustenabilitate trebuie <strong>să fie cel puțin egal cu cel din anul 2019</strong>, altfel proiectul va fi respins. În cazul întreprinderilor fără angajați în anul 2019, pentru a putea fi calculat puctajul aferent productivității muncii, se va introduce în cererea de finanţare cifra 1 (la număr de angajaţi), iar numărul de angajați în anul 3 de sustenabilitate trebuie să fie cel puțin 1.',
                        number: '2',
                        number2019: ''
                    },
                    supResult: [
                        {
                            id: 5,
                            title: 'Productivitatea muncii în IMM-uri în anul 3 de sustenabilitate',
                            number: '21',
                            canEdit: false,
                            hasPercent: true,
                        }
                    ],
                },
                uploadedDocument:null,
                warnTermene: false
            }
        },
        computed: {
            checks() {
                return this.$store.getters['checks/checks'];
            },
            allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },
        watch:{
            indicatori: {
                handler: function() {
                    this.getNrAngajati2019();
                    if(this.indicatori.indicators){
                        this.indicators = this.indicatori.indicators
                    }
                },
                deep: false
            },
            checks: {
                handler: function() {
                    this.completed = this.checks.indicatori;
                    if(this.completed)
                        this.$emit('formComplete')
                    else
                        this.$emit('formIncomplete')
                },
                deep: true,
                immediate: true
            },
            allData: {
                handler() {
                    if(this.allData && this.allData.financial_forecast_percent){
                        this.documentPercentage = this.allData.financial_forecast_percent
                        this.documentEmployees2019 = this.allData.employees_2019_xls
                        this.documentEmployees2026 = this.allData.employees_2026
                    }
                },
                deep: true,
                immediate: true
            }
        },
        mounted() {
            if(this.indicatori.indicators){
                this.indicators = this.indicatori.indicators
            }
            this.getNrAngajati2019();
        },
        methods: {
            getNrAngajati2019() {
                axios.get(api.API_ENDPOINTS.m3 + JSON.parse(localStorage.getItem('currentM3Company')).business_id + '/v1')
                    .then(response => {
                        if(response.data.nr_angajati_2019 < 1) {
                            this.nrAngajati2019 = 1
                            if(!this.indicators.employees.number2019)
                                this.indicators.employees.number2019 = 1
                        } else {
                            this.nrAngajati2019 = response.data.nr_angajati_2019
                            if(!this.indicators.employees.number2019)
                                this.indicators.employees.number2019 = response.data.nr_angajati_2019
                        }
                    })
            },
            movedItem(event) {
                if(event === 'child'){
                    this.$toast.success('Subactivitatea a fost mutată cu succes.');
                } else{
                    this.$toast.success('Activitatea a fost mutată cu succes.');
                }
            },
            formatIndicator(e) {
                return String(e).substring(0,5);
            },
            saveEdit(event, fromSection) {
                if(event === '0' && fromSection !== 'angajati'){
                    this.$swal({
                        title: 'Vei pierde 5 puncte din punctajul proiectului.<br>Ești sigur că vrei să continui?',
                        icon: 'warning',
                        confirmButtonText: 'Salvează',
                        showDenyButton: true,
                        denyButtonText: 'Anulează'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.editing = false
                            this.warnMessage = false
                        }
                    });
                } else{
                    this.editing = false
                }
            },
            toggleEdit(id) {
                if(!this.completed){
                    this.editing = id
                } else{
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.');
                }

                this.$emit('inputsChanged', true);
            },
            addSupResult() {
                if(this.completed) {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.');
                } else {
                    let lastItem = this.indicators.supResult[this.indicators.supResult.length -1];
                    this.indicators.supResult.push({
                        id: lastItem.id+1,
                        title: 'Te rugăm să modifici acest text',
                        number: '1',
                        canDelete: true,
                        canEdit: true,
                        hasPercent: false,
                    })
                    // Warning: Never try this at home!!!
                    document.getElementById('scrollAuxiliary').style.display = 'block';
                    this.editing = lastItem.id+1
                    this.$refs.scrollIndicatori.scrollIntoView({behavior: 'smooth', block: "end", inline: "nearest"});
                    document.getElementById('scrollAuxiliary').style.display = 'none';
                    this.$toast.success('Indicator suplimentar adăugat cu succes.');
                }
            },
            deleteIndicator(id) {
                if(this.completed) {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.');

                } else {
                    let removeIndex = this.indicators.supResult.findIndex( item => item.id === id );
                    this.indicators.supResult.splice( removeIndex, 1 );
                }
            },
            completeForm() {
                if(this.indicators.employees.number < this.indicators.employees.number2019) {
                    this.warnEmployees = true;
                    this.blinker = true;
                    this.completed = false;
                    return
                }
                if(this.documentEmployees2019 && Number(this.documentEmployees2019) != Number(this.indicators.employees.number2019)) {
                    this.blinker = true;
                    this.completed = false;
                    return
                }
                if(this.documentEmployees2026 && Number(this.documentEmployees2026) != Number(this.indicators.employees.number)) {
                    this.blinker = true;
                    this.completed = false;
                    return
                }
                if(this.documentPercentage && Number(this.documentPercentage) !== Number(this.indicators.supResult[0].number)) {
                    this.blinker = true;
                    this.completed = false;
                    return
                }
                if(this.completed) {
                    if(this.errorInput) {
                        this.$toast.error('Valoarea unui indicator nu poate fi mai mică de 1.')
                        this.completed = false
                        if(this.checks.indicatori !== this.completed)
                            this.$store.dispatch('checks/updateChecks', { name: 'indicatori', value: this.completed })
                    } else{
                        this.indicatorsSend = {
                            indicators: {
                                indicators: this.indicators,
                                checked: true
                            }
                        }

                        if(this.indicators.supResult[0].number < 10){
                            this.$emit('changePercentIndicator')
                        }

                        if(this.indicators.supAchievement.number < 1){
                            this.$emit('changeProductIndicator')
                        }
                        this.$store.dispatch('m3Sketch/saveAllDataProjectPart', this.indicatorsSend)
                            .then((firstResponse) => {
                                this.$toast.success(firstResponse.data);
                                this.$store.dispatch('m3Sketch/initializeIndicators')
                                if(this.checks.indicatori !== this.completed)
                                    this.$store.dispatch('checks/updateChecks', { name: 'indicatori', value: this.completed })
                            }).catch((xhr) => {
                                if (xhr.status === 422) {
                                    this.errors.record(xhr.responseJSON.errors);
                                }
                                this.$toast.error(xhr.response.data.message);
                                if(this.checks.indicatori !== this.completed)
                                    this.$store.dispatch('checks/updateChecks', { name: 'indicatori', value: this.completed })
                            });
                    }
                }
                else
                    if(this.checks.indicatori !== this.completed)
                        this.$store.dispatch('checks/updateChecks', { name: 'indicatori', value: this.completed })
            },
            checkScore(event) {
                this.errorInput = event.length < 1;
                if(event === '0'){
                    this.warnMessage = true
                } else if(event > 0){
                    this.warnMessage = false
                }
            },
            checkEmployees(event) {
                this.errorInput = event.length < 1;
                if(Number(event) < Number(this.indicators.employees.number2019)){
                    this.warnEmployees = true
                } else {
                    this.warnEmployees = false
                }
            },
            checkEmployeesTermene(event) {
                this.warnTermene = event != this.nrAngajati2019;
                this.checkEmployees(this.indicators.employees.number)
            },
            checkPercentage(event) {
                this.errorInput = event.length < 1;
                this.warnMessage2 = event < 10;
            },
            pickFile(doc){
                let input = this.$refs.fileUpload;
                input.click()
                this.uploadedDocument = doc;
            },
            uploadFile(e){
                let idCompanie = JSON.parse(localStorage.getItem('currentM3Company')).id
                let file =  new FormData;
                if(e.target.files.length>0){
                    file.append('file', e.target.files[0]);
                    if(this.uploadedDocument)
                        file.append('location' ,this.uploadedDocument.value);
                    file.append('_method','PUT');
                    axios.post(api.API_ENDPOINTS.m3company + idCompanie + '/upload/financial-forecasts',file)
                        .then(response => {
                            this.$toast.success('Document încărcat cu succes')
                            this.documentPercentage = response.data.financial_forecast
                            this.documentEmployees2026 = response.data.employees_value
                            this.documentEmployees2019 = response.data.employees_2019_xls
                            this.uploadedDocument = null;
                            this.$refs.fileUpload.value = null;
                        }).catch(xhr => {
                            this.uploadedDocument = null;
                            this.$refs.fileUpload.value = null;
                            this.$toast.error(xhr.response.data.message)
                        });
                }
            },
            downloadForecast() {
                let idCompanie = JSON.parse(localStorage.getItem('currentM3Company')).id
                axios({url: api.API_ENDPOINTS.m3company + idCompanie + '/documents/financial_forecasts', method: 'GET', responseType: 'blob'})
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Previziuni financiare.xlsx');
                        document.body.appendChild(link);
                        link.click();
                        this.raportDownload = false
                    });
            }
        }
    }
</script>

<style scoped>
.excel-download{
	width: 20px;
	margin-right: 10px;
}
.add-button{
    min-width: 370px;
}
.white-box{
    background: #fff;
    padding: 20px;
    position: relative;
}
.data-group{
    margin: auto;
    width: 90%;
}
.flex{
    display: flex;
}
.warn{
    background: var(--dangerColor);
    border-radius: 2px;
    padding: 5px 20px;
    display: flex;
    justify-content: center;
    color: #fff;
    margin-top: 10px;
    font-size: 14px;
}
.yellow-warn{
    background: #ffeab8 !important;
    color: #515679 !important;
}
.yellow-warn-termene{
    background: #ffeab8 !important;
    color: #515679 !important;
    margin-left: 90px;
}
.danger-warn-text{
    color: #f57680;
    font-size: 15px;
    margin-bottom: 5px;
    margin-top: 55px;
    font-weight: 700;
    display: flex;
    justify-content: flex-end;
}
.red-warn{
    background: linear-gradient(to bottom, #fd928d, #f4767f);
    display: flex;
    justify-content: space-between;
    padding: 20px;
    align-items: center;
    margin-left: 90px;
}
.red-warn .sad-face{
    max-height: 40px;
    margin-right: 20px;
    filter: brightness(0) invert(1);
    align-self: flex-start;
}
.red-warn-text h3{
    font-size: 18px;
    color: #fff;
    margin-bottom: 15px;
}
.red-warn-text p{
    font-size: 13px;
    color: #fff;
    max-width: 870px;
}
.red-warn-download{
    display: flex;
    flex-direction: column;
}
.red-warn-download:hover{
    text-decoration: none;
}
.red-warn-download p{
    font-size: 13px;
    color: #fff;
    max-width: 130px;
    text-align: center;
}
.red-warn-download img{
    max-height: 40px;
    filter: brightness(0) invert(1);
    object-fit: contain;
    margin-bottom: 10px;
}
.space-between{
    justify-content: space-between;
}
.adauga-asociat{
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.adauga-asociat .title{
    font-size: 14px;
    color: #515679;
    text-transform: uppercase;
}
.activitate{
    margin-top: 30px;
}
.activitate .header{
    background: #e9eaec;
    padding: 15px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.purple .header{
    background: #e6cfea !important;
}
.purple .sub-item{
    background: #f4e5f7 !important;
}
.activitate .header span{
    color: #515679;
}
.actions{
    position: absolute;
    right: -55px;
}
.activitate .actions svg:first-child{
    margin-right: 10px;
}
.activitate .actions svg{
    color: #9da1af;
    cursor: pointer;
}
.activitate .actions svg:hover{
    color: #7f838f;
}
.sub-item{
    margin-left: 90px;
    margin-top: 10px;
    background: #f8f9f9;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 30px;
    position: relative;
}
.green{
    margin-left: 90px;
    margin-top: 10px;
    background: #cdfaee;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 30px;
}
.green-item{
    width: 100%;
    margin-top: 10px;
    background: #cdfaee;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 30px;
    cursor: pointer;
    transition: 0.4s;
	color: #000;
	font-size: 14px;
}
.green-item-nohover{
    width: 100%;
    margin-top: 10px;
    background: #cdfaee;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 30px;
    transition: 0.4s;
    color: #000;
    font-size: 14px;
}
.green-item:hover{
	text-decoration: none;
}
.red-item, .green-item-special{
    width: 100%;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.4s;
}
.red-item{
    background: #ffbbbb;
}
.green-item-special{
    background: #cdfaee;
}
.red-item img, .green-item-special img{
    max-height: 20px;
    margin-left: 15px;
}
.red-item p, .green-item-special p{
    font-size: 25px;
    font-weight: 700;
}
.red-item p{
    color: #ff5555;
}
.green-item-special p{
    color: #515679;
}
.green-item p{
    text-align: center;
}
.green-item:hover{
    background: #b3e5d7;
}
.sub-item-flex{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.yellow{
    margin-left: 90px;
    margin-top: 10px;
    background: #ffeab8;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
}
.sub-item .title{
    font-size: 14px;
    color: #515679;
    width: 100%;
}
.sub-item >>> input{
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
    line-height: 23px;
    width: 60%;
}
.adauga-asociat{
    margin-top: -20px;
}
.add-button{
    margin-top: 0 !important;
}
.switch-box{
    text-align: right;
    margin-top: 25px;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
.points{
    font-size: 22px;
    font-weight: 800;
    line-height: 1;
}
.subtitle{
    font-size: 12px !important;
    font-weight: inherit !important;
}
.title >>> input:first-child{
    font-size: 14px !important;
    font-weight: inherit !important;
    line-height: 1;
    padding: 0;
    max-height: 22px;
	text-align: left;
}
.title >>> input{
    font-size: 22px !important;
    font-weight: 800;
    line-height: 1;
    padding: 0;
    text-align: center;
    max-height: 22px;
}
.pointer-none{
    pointer-events: none;
    opacity: 0.5;
}
.angajatiItem {
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	padding: 0 15px;
	border-left: 2px solid #fff;
	min-width: 170px;
}
.sub-item.yellow .title > span:not(.angajatiItem) {
	width: 100%;
}
.angajatiTitle{
	margin-bottom: 15px;
}
.editAngajati {
	text-align: center;
	align-items: center;
	display: flex;
	justify-content: center;
}
.editAngajati input{
	text-align: center !important;
}
.blinker{
	animation: blinker 1.2s cubic-bezier(.5, 0, 1, 1) infinite alternate;
}
@media (max-width: 1700px){
    .white-box{
        padding: 20px 35px !important;
    }
    .actions{
        right: -35px;
        display: flex;
        flex-direction: column;
    }
    .actions svg:first-child{
        margin-bottom: 5px;
        margin-right: 0;
    }
}
@media screen and (max-width: 1440px){
  .red-warn-text{
    padding: 0px 15px;
  }
  .danger-warn-text {
    margin-top: 15px;
  }
}
</style>
